import axios from "axios";
import {API_BASE_URL} from "../constants/api";
import {ACCESS_TOKEN} from "../constants/auth";
import JournalService from "./JournalService";

const AETService = {};

AETService.loadAetResults = async function (file, type) {
    let data = new FormData();
    data.append("file", file);
    data.append("type", type);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/aet/save`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

AETService.getAETResults = async function (page, limit, text) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/aet/get`,
        params: {
            page: page - 1,
            limit: limit,
            text:  text === undefined ? null : text
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

AETService.getAETResultByIINAndType = async function (iin, type) {
     return axios({
        method: "get",
        url: API_BASE_URL + `/api/form/aet/get-by`,
        params: {
            iin: iin,
            type: type
        },
        headers: {
            "Content-Type": "application/json"
        }
    });
}

export default AETService;